import React from 'react'
import moment from 'moment'
import { framework_tool, component_tool } from '@/tool'
let { WizAvatarUpload, ossFileUtils } = framework_tool
let { Wizmessage } = component_tool
const clearWizCallBack = []
import { WizAuthority } from '../../../../common'

const validator = (rule, value, callback) => {
  if (value) {
    if (value.groupId) {
      callback()
      return
    }
    if (value.orgIds && value.orgIds.length) {
      callback()
      return
    }
    if (value.positionIds && value.positionIds.length) {
      callback()
      return
    }
    if (value.positionCategoryIds && value.positionCategoryIds.length) {
      callback()
      return
    }
    if (value.personIds && value.personIds.length) {
      callback()
      return
    }
    // if (value.isAll) {
    //   callback()
    //   return;
    // }
  }
  callback('请选择话题受众')
}

export const createColumns = (self, record) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '话题名称',
      name: 'title',
      dataIndex: 'title',
      formItem: {
        maxlength: 10,
        rules: [{ required: true, message: '请输入话题名称' }]
      }
    },
    {
      title: '话题简介',
      name: 'introduce',
      dataIndex: 'introduce',
      formItem: {
        type: 'textarea',
        maxlength: 200,
        rules: [{ required: true, message: '请输入话题简介' }]
      }
    },
    {
      title: '有效日期',
      name: 'date',
      dataIndex: 'date',
      formItem: {
        type: 'date~',
        format: 'YYYY-MM-DD',
        formatInit: (record) => { return [moment(record.start), moment(record.end)] },
        rules: [{ required: true, message: '请选择有效日期' }]
      }
    },
    {
      title: '上传头像',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form
          let initialValue = undefined
          if (record && record.icon) {
            initialValue = [{ fileId: record.icon }]
          }
          return (
            <>
              {
                getFieldDecorator('icon', { initialValue, rules: [{ required: true, message: '请选择上传头像' }] })(
                  <WizAvatarUpload
                    key='icon'
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={300 / 300}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过1MB!')
                      }
                      return isLt1M
                    }}
                  />
                )
              }
            </>
          )
        }
      }
    },
    {
      title: '上传背景',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form
          let initialValue = undefined
          if (record && record.img) {
            initialValue = [{ fileId: record.img }]
          }
          return (
            <>
              {
                getFieldDecorator('img', { initialValue, rules: [{ required: true, message: '请选择上传背景' }] })(
                  <WizAvatarUpload
                    key='img'
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={800 / 320}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过1MB!')
                      }
                      return isLt1M
                    }}
                  />
                )
              }
            </>
          )
        }

      }
    },
    {
      title: '话题受众',
      name: 'authInfo',
      dataIndex: 'authInfo',
      formItem: {
        type: 'diy',
        diy: WizAuthority,
        rules: [{ required: true, validator }],
        initialValue: record && record.authInfo,
        record: {
          authInfo: record && record.authInfo
        },
        // showBlock: false,
        keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds'],
      },
      onClearWiz: (callback) => callback && clearWizCallBack.push(callback)
    },
    {
      title: '话题状态',
      name: 'state',
      dataIndex: 'state',
      dict: [
        { code: 1, codeName: '有效' },
        { code: 0, codeName: '无效' }
      ],
      formItem: {
        type: 'radio',
        initialValue: 1,
        rules: [{ required: true, message: '请选择话题状态' }]
      }
    },
    {
      name: 'topping',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'toppingTime',
      formItem: {
        type: 'hidden'
      }
    }
  ]
}
